import _ from 'lodash';
import { DashboardWidget } from '../types/dashboard.types';
import { WhereCondition } from '../types/server.types';

export function convertWhereToFilterByFormat(where: WhereCondition[]) {
  const filterByList = [];
  for (const condition of where) {
    const level = condition.field;
    const type = 'generic';
    if (condition.operator === 'LIKE' || condition.operator === 'IN') {
      for (const value of condition.values) {
        filterByList.push({
          filterBy: {
            level,
            value,
          },
          type,
        });
      }
    }
  }
  return filterByList;
}

export function convertFilterByFormatToGenericWhereFormat(filterByList: any[]): WhereCondition[] {
  const where: WhereCondition[] = [];
  const filtersByField = _.groupBy(filterByList, 'filterBy.level');
  for (const [field, filters] of Object.entries(filtersByField)) {
    if (field) {
      where.push({
        field,
        operator: 'LIKE',
        values: filters.map(filter => filter.filterBy.value).filter(Boolean),
      });
    }
  }
  return where;
}

export function convertWidgetForFE(widget: any) {
  if (widget.where) {
    // clone only what we need
    const clonedWidget = _.cloneDeep(widget);
    clonedWidget.filterTagList = convertWhereToFilterByFormat(clonedWidget.where);
    delete clonedWidget.where;
    return clonedWidget;
  }
  return widget;
}

export function convertWidgetForBE(widget: any) {
  if (hasToUseWhereFilter(widget)) {
    // clone only what we need
    const clonedWidget = _.cloneDeep(widget);
    clonedWidget.where = convertFilterByFormatToGenericWhereFormat(clonedWidget.filterTagList);
    delete clonedWidget.filterTagList;
    return clonedWidget;
  }
  return widget;
}

export function convertViewForFE(view) {
  // view.config.widgets = view.config.widgets.map(convertWidgetForFE);
  return view;
}

export function convertViewForBE(view) {
  // const widgets = view.config.widgets.map(convertWidgetForBE);
  // return { ...view, config: { ...view.config, widgets } };
  return view;
}

/**
 * The where filter is only available for the generic data sources for now
 * @param widget
 */
export function hasToUseWhereFilter(widget) {
  console.log('hasToUseWhereFilter', widget);
  if (widget?.adAccounts && widget?.adAccounts.every(adAccount => adAccount.isCustomReportAccount)) {
    return true;
  }
  return false;
}
